import type { IColumn } from '@creditflowresearch/uilib/Table/DataTable';

import columnsStyles from '../columnsTabContent.module.scss';

export const dragColumn: IColumn = {
  name: 'drag',
  title: '',
  width: 36,
  minWidth: 36,
  maxWidth: 36,
  isDraggable: true,
  className: columnsStyles.dragCell,
};
